import { computed, toValue } from "vue";
import { FormFieldContextKey, InputFieldContextKey } from "../Symbols.mjs";
import { injectWithSelf } from "../utils.mjs";
function useIsFieldRequired() {
  const { validators = [] } = injectWithSelf(FormFieldContextKey, {});
  const { required: requiredOverwrittenAtInput } = injectWithSelf(
    InputFieldContextKey,
    {}
  );
  return computed(() => {
    if (requiredOverwrittenAtInput !== null && requiredOverwrittenAtInput !== void 0) {
      return requiredOverwrittenAtInput;
    }
    return toValue(validators).some(
      (validator) => validator.name === "required"
    );
  });
}
export {
  useIsFieldRequired as default
};
//# sourceMappingURL=useIsFieldRequired.mjs.map
